// extracted by mini-css-extract-plugin
module.exports = {"root":"_3R7y5","title":"_3Gfft","subtitle":"_2DpPf"};